import { css, createGlobalStyle } from 'styled-components';

const FontSize = createGlobalStyle`
  :root{
    --fs-xs: 8px;
    --fs-sm: 10px;
    --fs-base: 12px;
    --fs-md: 14px;
    --fs-mdx: 16px;
    --fs-lg: 18px;
  }
  ._font-base{
    --fs-xs: 8px;
    --fs-sm: 10px;
    --fs-base: 12px;
    --fs-md: 14px;
    --fs-mdx: 16px;
    --fs-lg: 18px;
    font-size: 12px;
  }
  ._font-md{
    --fs-xs: 8px;
    --fs-sm: 12px;
    --fs-base: 14px;
    --fs-md: 16px;
    --fs-mdx: 18px;
    --fs-lg: 18px;
    font-size: 14px;
  }
  ._font-lg{
    --fs-xs: 8px;
    --fs-sm: 12px;
    --fs-base: 16px;
    --fs-md: 16px;
    --fs-mdx: 18px;
    --fs-lg: 18px;
    font-size: 16px;
  }
  //小 18,14,12,10,8
  .fs-xs{
    font-size: var(--fs-xs)
  }
  .fs-sm{
    font-size: var(--fs-sm)
  }
  .fs-base{
    font-size: var(--fs-base)
  }
  .fs-md{
    font-size: var(--fs-md)
  }
  .fs-mdx{
    font-size: var(--fs-mdx)
  }
  .fs-lg{
    font-size: var(--fs-lg)
  }
 `;

export default FontSize;
